module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appFoot"
  }, [_c('router-link', {
    class: {
      on: _vm.currentRoute === 'home'
    },
    attrs: {
      "replace": "",
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "icon icon-home"
  }), _vm._v(" "), _c('span', [_vm._v("首页")])]), _vm._v(" "), _c('router-link', {
    class: {
      on: _vm.currentRoute === 'category'
    },
    attrs: {
      "replace": "",
      "to": "/category"
    }
  }, [_c('i', {
    staticClass: "icon icon-apps"
  }), _vm._v(" "), _c('span', [_vm._v("搜索")])]), _vm._v(" "), _c('router-link', {
    class: {
      on: _vm.currentRoute === 'more'
    },
    attrs: {
      "replace": "",
      "to": "/more"
    }
  }, [_c('i', {
    staticClass: "icon icon-more"
  }), _vm._v(" "), _c('span', [_vm._v("我的")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33dbf14a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/components/AppFoot.vue
// module id = 315
// module chunks = 0